import './style.modules.scss'

import { Spacer } from '@ampcore/adel-react'
import { SpacerSpacing } from '@ampcore/adel-react'
import React, { useEffect, useState } from 'react'
import xss from 'xss'

import { useEventListener } from '../../hooks/useEventListener'
import { CustomEventType } from '../../types/events/CustomEventType.enum'
import { Link } from '../../types/Link.type'

export type SuggestedLinksTile = {
  superheadline?: string
  heading?: string
  content?: string
  link?: Link
}

export type SuggestedLinksProps = {
  title?: string
  tile?: SuggestedLinksTile[]
  componentSpacing?: SpacerSpacing
  testId?: string
}

export const SuggestedLinks = (props: SuggestedLinksProps) => {
  const { title, tile, componentSpacing, testId } = props
  const [isVisible, setIsVisible] = useState(false)
  const isSearchPage = window.location.pathname.startsWith('/search')

  useEffect(() => {
    if (!isSearchPage) {
      setIsVisible(true)
    }
  }, [isSearchPage])

  useEventListener(CustomEventType.NO_SEARCH_RESULTS, () => {
    setIsVisible(true)
  })

  if (!isVisible || !tile || tile.length === 0) {
    return null
  }

  return (
    <Spacer spacing={componentSpacing}>
      <div
        className={`SuggestedLinks Content u-textPrimary u-paddingVert48 u-bgColorStone`}
      >
        <div className="u-sizeConstrained">
          {title && (
            <div
              className="Type-3 u-paddingBottom20"
              dangerouslySetInnerHTML={{ __html: xss(title) }}
              data-testid={testId ? `${testId}-title` : undefined}
            />
          )}
          <div
            className={`SuggestedLinks Grid Grid--withGutter Grid--fill u-sm-block`}
          >
            {tile.map((tile, index) => (
              <div
                className="SuggestedLinks-tile Content u-border u-margin8 u-paddingBottom16 u-textColorNeutral u-paddingHoriz16 u-paddingVert24 u-bgColorWhite"
                key={index}
              >
                {tile.superheadline && (
                  <div
                    className="Type-5 u-textEyebrow"
                    dangerouslySetInnerHTML={{
                      __html: xss(tile.superheadline)
                    }}
                    data-testid={
                      testId
                        ? `${testId}-tile-${index}-superheadline`
                        : undefined
                    }
                  />
                )}
                {tile.heading && (
                  <div
                    className="Type-3 u-marginTop8"
                    dangerouslySetInnerHTML={{ __html: xss(tile.heading) }}
                    data-testid={
                      testId ? `${testId}-tile-${index}-heading` : undefined
                    }
                  />
                )}
                {tile.content && (
                  <div
                    className="SuggestedLinks-content u-marginTop8"
                    dangerouslySetInnerHTML={{ __html: xss(tile.content) }}
                    data-testid={
                      testId ? `${testId}-tile-${index}-content` : undefined
                    }
                  />
                )}
                {tile.link?.name && (
                  <a
                    className="Button Button--small Button--secondary Button--secondary--action-blue u-marginTop40"
                    href={tile.link.url}
                    data-analytics={tile.link.analyticsName}
                    target={tile.link.target}
                    data-testid={testId ? `${testId}-card-${index}-link` : null}
                    dangerouslySetInnerHTML={{
                      __html: xss(tile.link.name)
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Spacer>
  )
}
